/*export default function Footer() {
  return (
    <footer className="bg-dark text-light mt-5">
      <div className="container py-4">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h5 className="fw-bold mb-1">PMS</h5>
            <small className="text-muted">
              Trusted skincare products for all ages.
            </small>
          </div>

          <div className="col-md-6 text-md-end mt-3 mt-md-0">
            <small>
              © {new Date().getFullYear()} PMS. All rights reserved.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}
*/


export default function Footer() {
  return (
    <footer
      className="text-light mt-5"
      style={{
        backgroundColor: "#0d6efd", // Option: "#198754" (green), "#0b1c2d" (navy)
      }}
    >
      <div className="container py-4">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h5 className="fw-bold mb-1">BIS</h5>
            <small className="opacity-75">
              Professional Product Information System
            </small>
          </div>

          <div className="col-md-6 text-md-end mt-3 mt-md-0">
            <small className="opacity-75">
              © {new Date().getFullYear()} PMS. All rights reserved.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}
